import './Link.css.proxy.js';
/* src/components/news/Link.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_text,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	text,
	toggle_class
} from "../../web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let a;
	let figure;
	let img;
	let img_src_value;
	let img_alt_value;
	let div;
	let p;
	let t0_value = /*newsItem*/ ctx[0].dateFormatted() + "";
	let t0;
	let h3;
	let t1_value = /*newsItem*/ ctx[0].title + "";
	let t1;
	let a_href_value;

	return {
		c() {
			a = element("a");
			figure = element("figure");
			img = element("img");
			div = element("div");
			p = element("p");
			t0 = text(t0_value);
			h3 = element("h3");
			t1 = text(t1_value);
			this.h();
		},
		l(nodes) {
			a = claim_element(nodes, "A", { href: true, class: true });
			var a_nodes = children(a);
			figure = claim_element(a_nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);

			img = claim_element(figure_nodes, "IMG", {
				src: true,
				alt: true,
				loading: true,
				class: true
			});

			figure_nodes.forEach(detach);
			div = claim_element(a_nodes, "DIV", { class: true });
			var div_nodes = children(div);
			p = claim_element(div_nodes, "P", { class: true });
			var p_nodes = children(p);
			t0 = claim_text(p_nodes, t0_value);
			p_nodes.forEach(detach);
			h3 = claim_element(div_nodes, "H3", { class: true });
			var h3_nodes = children(h3);
			t1 = claim_text(h3_nodes, t1_value);
			h3_nodes.forEach(detach);
			div_nodes.forEach(detach);
			a_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = /*newsItem*/ ctx[0].featuredImage?.getSized("thumbnail") || "/images/keyvisual.jpg")) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = /*newsItem*/ ctx[0].title);
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-1jjqcnf");
			attr(figure, "class", "svelte-1jjqcnf");
			attr(p, "class", "date svelte-1jjqcnf");
			attr(h3, "class", "svelte-1jjqcnf");
			attr(div, "class", "contents svelte-1jjqcnf");
			attr(a, "href", a_href_value = "/news/" + /*newsItem*/ ctx[0].id);
			attr(a, "class", "svelte-1jjqcnf");
			toggle_class(a, "reverse", /*reverse*/ ctx[1]);
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, figure);
			append(figure, img);
			append(a, div);
			append(div, p);
			append(p, t0);
			append(div, h3);
			append(h3, t1);
		},
		p(ctx, [dirty]) {
			if (dirty & /*newsItem*/ 1 && img.src !== (img_src_value = /*newsItem*/ ctx[0].featuredImage?.getSized("thumbnail") || "/images/keyvisual.jpg")) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*newsItem*/ 1 && img_alt_value !== (img_alt_value = /*newsItem*/ ctx[0].title)) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty & /*newsItem*/ 1 && t0_value !== (t0_value = /*newsItem*/ ctx[0].dateFormatted() + "")) set_data(t0, t0_value);
			if (dirty & /*newsItem*/ 1 && t1_value !== (t1_value = /*newsItem*/ ctx[0].title + "")) set_data(t1, t1_value);

			if (dirty & /*newsItem*/ 1 && a_href_value !== (a_href_value = "/news/" + /*newsItem*/ ctx[0].id)) {
				attr(a, "href", a_href_value);
			}

			if (dirty & /*reverse*/ 2) {
				toggle_class(a, "reverse", /*reverse*/ ctx[1]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	
	let { newsItem } = $$props;
	let { reverse = false } = $$props;

	$$self.$$set = $$props => {
		if ("newsItem" in $$props) $$invalidate(0, newsItem = $$props.newsItem);
		if ("reverse" in $$props) $$invalidate(1, reverse = $$props.reverse);
	};

	return [newsItem, reverse];
}

class Link extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { newsItem: 0, reverse: 1 });
	}
}

export default Link;
//# sourceMappingURL=Link.js.map
